module.exports = __webpack_public_path__ + "img/E-WEB-Goal-9.b2788404.png";